import { render, staticRenderFns } from "./TextWithIconTiles.vue?vue&type=template&id=10169921"
import script from "./TextWithIconTiles.vue?vue&type=script&lang=js"
export * from "./TextWithIconTiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports